<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialog(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
    >
      <el-input type="text" v-model="channel" placeholder="Channel" clearable />
      <el-input
        type="text"
        v-model="title"
        placeholder="Title"
        clearable
        class="mt10"
      />
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      channel: '',
      title: ''
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog'])
  },
  methods: {
    ...mapMutations('youtubeWhitelist', ['setDialog', 'setFilter', 'setPage']),
    ...mapActions('youtubeWhitelist', ['readWhitelist']),

    filter() {
      this.setFilter({
        channel: this.channel,
        title: this.title
      })
      this.setPage(1)
      this.readWhitelist()
      this.setDialog(false)
    },

    clear() {
      this.setFilter({})
      this.readWhitelist()
      this.channel = ''
      this.title = ''
      this.setDialog(false)
    }
  }
}
</script>
